import React, { Component, ReactNode } from 'react';
import './tree.css';

class WorkFlowViewComponent extends Component<Props, State> {
  public render(): ReactNode {
    return <div id='workflow' className={'w-full bg-f-gray border-[1px] border-[#E0E4E8] rounded-lg'} />;
  }
}

interface Props {
  close: () => void;
}

class State {}

export default WorkFlowViewComponent;
